/**
 * „Kitul de recuperare": fișierul .txt cu fraza de recuperare și instrucțiunile
 * de folosire. Generat în browser, nu trece prin server.
 */
import type { TFunction } from 'i18next';

import { downloadTextFile } from '@/lib/download';

export const RECOVERY_KIT_FILENAME = 'cerbes-recovery-kit.txt';

export function downloadRecoveryKit(phrase: string, email: string, t: TFunction): void {
  const numbered = phrase
    .split(' ')
    .map((word, i) => `${String(i + 1).padStart(2, ' ')}. ${word}`)
    .join('\n');
  downloadTextFile(
    RECOVERY_KIT_FILENAME,
    [
      t('recovery.kit_title'),
      '='.repeat(40),
      '',
      `${t('recovery.kit_account')}: ${email}`,
      `${t('recovery.kit_date')}: ${new Date().toISOString().slice(0, 10)}`,
      `${t('recovery.kit_url')}: ${window.location.origin}/recover`,
      '',
      `${t('recovery.phrase_label')}:`,
      '',
      numbered,
      '',
      phrase,
      '',
      t('recovery.kit_instructions'),
      '',
    ].join('\n'),
  );
}
